import type { ShipmentDirection } from '../../domain/shipment';

interface DirectionChoiceProps {
  value: ShipmentDirection;
  onChange: (direction: ShipmentDirection) => void;
  disabled?: boolean;
}

/** Outbound vs customer return, shown at the top of shipment creation. */
export function DirectionChoice({ value, onChange, disabled }: DirectionChoiceProps) {
  return (
    <fieldset className="direction-choice" disabled={disabled}>
      <legend>Direction</legend>
      <label className={value === 'OUTBOUND' ? 'selected' : undefined}>
        <input
          type="radio"
          name="shipment-direction"
          value="OUTBOUND"
          checked={value === 'OUTBOUND'}
          onChange={() => onChange('OUTBOUND')}
        />
        <span>
          <strong>Outbound</strong>
          <span>Tidal → customer</span>
        </span>
      </label>
      <label className={value === 'RETURN' ? 'selected' : undefined}>
        <input
          type="radio"
          name="shipment-direction"
          value="RETURN"
          checked={value === 'RETURN'}
          onChange={() => onChange('RETURN')}
        />
        <span>
          <strong>Customer return</strong>
          <span>Customer site → Tidal</span>
        </span>
      </label>
    </fieldset>
  );
}
